import { render } from "./SearchHistory.vue?vue&type=template&id=d3813d40&scoped=true"
import script from "./SearchHistory.vue?vue&type=script&lang=js"
export * from "./SearchHistory.vue?vue&type=script&lang=js"

import "./SearchHistory.vue?vue&type=style&index=0&id=d3813d40&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-d3813d40"

export default script